import React from "react"
import { InfoBox, Label, StyledStatus } from "./OrderHeader.styled"
import { OrderPayment, OrderPaymentAdyen } from "lib/types/generated/graphql-types"

type Props = {
  payment: OrderPayment
}

const PaymentStatus = ({ payment }: Props) => {
  function isOrderNotBrinkZeroPayment(object: OrderPayment): object is OrderPaymentAdyen {
    return object?.providerName !== "BrinkZeroPayment"
  }

  return (
    <>
      {isOrderNotBrinkZeroPayment(payment) && (
        <InfoBox>
          <Label>Payment status</Label> <StyledStatus status={payment?.status || "-"} />
        </InfoBox>
      )}
    </>
  )
}

export default PaymentStatus
